var _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpert(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 58,
    viewBox: "0 0 52 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.2388 45.2383C50.0961 44.1668 51.2404 42.1855 51.2404 40.0413V17.9587C51.2404 15.8145 50.0961 13.8332 48.2388 12.7617L29.1187 1.73002C27.263 0.659386 24.9773 0.659384 23.1217 1.73002L4.00151 12.7617C2.14425 13.8332 1 15.8145 1 17.9587V40.0413C1 42.1855 2.14425 44.1668 4.00151 45.2383L23.1217 56.27C24.9773 57.3406 27.263 57.3406 29.1187 56.27L48.2388 45.2383Z",
    fill: "url(#paint0_radial_18355_93809)",
    stroke: "url(#paint1_linear_18355_93809)",
    strokeWidth: 1.29612
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8349 28.8339C29.7089 28.8339 32.8495 25.6933 32.8495 21.8193C32.8495 17.9452 29.7089 14.8047 25.8349 14.8047C21.9608 14.8047 18.8203 17.9452 18.8203 21.8193C18.8203 25.6933 21.9608 28.8339 25.8349 28.8339Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7852 42.8673C13.7852 37.438 19.1864 33.0469 25.8362 33.0469C27.183 33.0469 28.4877 33.2292 29.7083 33.5659",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.864 37.2523C39.864 38.3045 39.5694 39.3006 39.0503 40.1423C38.7557 40.6474 38.3769 41.0963 37.942 41.461C36.9599 42.3449 35.6692 42.864 34.2523 42.864C32.204 42.864 30.4223 41.7697 29.4543 40.1423C28.9352 39.3006 28.6406 38.3045 28.6406 37.2523C28.6406 35.4846 29.4543 33.8993 30.745 32.8752C31.713 32.1036 32.9336 31.6406 34.2523 31.6406C37.3527 31.6406 39.864 34.1518 39.864 37.2523Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0625 37.2498L33.4514 38.6387L36.4396 35.875",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_18355_93809",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.1202 29) rotate(90) scale(57.5167 49.8217)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#121212"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_18355_93809",
    x1: 4.99639,
    y1: 2.41667,
    x2: 41.5768,
    y2: 63.7624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289672,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.696447,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpert);
export default __webpack_public_path__ + "static/media/expert.b4b652a6c3b6a673b05a01328e0f371e.svg";
export { ForwardRef as ReactComponent };